import { render, staticRenderFns } from "./taskh.vue?vue&type=template&id=08c21b63&"
import script from "./taskh.vue?vue&type=script&lang=js&"
export * from "./taskh.vue?vue&type=script&lang=js&"
import style0 from "./taskh.vue?vue&type=style&index=0&id=08c21b63&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports